export default async function setupLinkedin() {
  const urlsModule = await SystemJS.import('canopy-urls!sofe');
  const env = urlsModule.default.getEnvironment();

  if (
    (env === urlsModule.default.PRODUCTION_ENVIRONMENT ||
      env === urlsModule.default.STAGING_ENVIRONMENT ||
      env === urlsModule.default.INTEGRATION_ENVIRONMENT)
  ) {

    const linkedinTracker = document.createElement('img');
    linkedinTracker.src = "https://dc.ads.linkedin.com/collect/?pid=49505&fmt=gif"
    linkedinTracker.height = 1;
    linkedinTracker.width = 1;
    linkedinTracker.style.display = "none";

    document.body.appendChild(linkedinTracker);
  }
}
